export default "https://assets.egbcdn.net/assets/packs/_/images/app/apk/apk-6-f45dd93a740296f84aa8969d34d75b9d.png";